var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-col-12"},[_c('page-header',{attrs:{"title":"dataTable.contract.title","actions":_vm.pageActions}}),_c('ancestryline-data-table',{attrs:{"data-function":_vm.dataFunction,"columns":_vm.columns}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }